module.exports = {"content":{},"productInfo":{"code":"{0015FD9F-312F-45FD-AD7A-5FFAE0A41751}","name":"スウェーデン語　初中級","serialHead":"BPWRK","courseResourceIDs":[{"levelNo":1,"resourceID":"7c7644de45a979a5a59e1c5c82a53956e2cdc548"},{"levelNo":2,"resourceID":"972fbe1ab619def9ddd26a326271af58fa644d6b"},{"levelNo":3,"resourceID":"d6b95015cb294a9deebe2cb298e4a153ca01c9cb"}],"language":"sv-SE","challengeCount":21434},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1